import {TextButton} from '../../index'

const CancelButton = ({className, onClick}) => {
    return (
        <TextButton className={className} clickHandler={onClick} secondaryButton>Cancel</TextButton>
    )
}

export default CancelButton